export function redirectToExternalUrl(
  baseUrl,
  params = {},
) {
  const url = new URL(baseUrl)

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  window.location.href = url.toString()
}
